export default {
  color: `headerLink`,
  textDecoration: `none`,
  userSelect: `none`,
  cursor: `pointer`,
  whiteSpace: `pre`,
  fontWeight: 700,
  marginLeft: `30px`,
  transition: `all 250ms ease`,
  p: 0,
  ':visited': {
    color: `headerLink`,
  },
  ':hover': {
    color: 'hoveredHeaderLink',
  },
};
